import React from "react";
import AppBar from "@mui/material/AppBar";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
// import LanguageSelect from "./LanguageSelect";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import Logo from "../assets/images/Logo.svg";

function AppBarLabel({ label }) {
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const { t } = useTranslation();

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"), {
    defaultMatches: true,
    noSsr: false,
  });
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"), {
    defaultMatches: true,
    noSsr: false,
  });
  const isTablet = useMediaQuery("(max-width:1500px)");
  const isTabletM = useMediaQuery("(max-width:1200px)");

  return (
    <Toolbar
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
      }}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={2} align="left">
          <Link to="/"> {label}</Link>
        </Grid>

        <Grid
          item
          xs={isTablet ? (isTabletM ? 6 : 4) : 3}
          container
          //  spacing={isTablet? 9:0}
          alignItems="center"
          align="right"
          sx={{
            pr: 2,
            "& .MuiTypography-root": {
              fontFamily: "Poppins",
              fontWeight: 600,
              "&:hover": { color: "#0FB694" },
            },
          }}
        >
          {/* <Grid item xs={4}>
            <LanguageSelect />
          </Grid> */}
          {mdUp ? (
            <>
              <Grid item xs={4}>
                <Link
                  to="/login"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <Typography sx={{}}>{t("login")}</Typography>
                </Link>
              </Grid>
              <Grid item xs={4}>
                <Link
                  to="/register"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <Typography> {t("sign_up")} </Typography>
                </Link>
              </Grid>
            </>
          ) : (
            <Grid item xs={8}>
              <MenuIcon
                onClick={handleOpenUserMenu}
                sx={{ "&.MuiSvgIcon-root": { "&:hover": { fill: "#0FB694" } } }}
              />

              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  // horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  // horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <Link
                  to="/login"
                  style={{ textDecoration: "none", color: "black" }}
                  sx={{}}
                >
                  <MenuItem sx={{ fontFamily: "Poppins", fontWeight: 600 }}>
                    {t("login")}
                  </MenuItem>
                </Link>
                <Link
                  to="/register"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <MenuItem sx={{ fontFamily: "Poppins", fontWeight: 600 }}>
                    {t("sign_up")}
                  </MenuItem>
                </Link>
              </Menu>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Toolbar>
  );
}

// const darkTheme = createTheme({
//   palette: {
//     mode: "white",
//     primary: {
//       main: "#1976d2",
//     },
//   },
// });

export default function Navbar() {
  const isMobile = useMediaQuery("(max-width:900px)");
  return (
    <Stack sx={{ flexGrow: 1 }}>
      <ThemeProvider>
        <AppBar position="static" color="primary" elevation={0}>
          <AppBarLabel
            label={
              <img
                src={Logo}
                height="50"
                width={isMobile ? "150%" : "60%"}
                alt=""
                style={{
                  padding: isMobile ? "0px 0px" : "0px 10px",
                  marginLeft: isMobile ? "40px" : {},
                  marginTop: "15px",
                  marginBottom: "10px",
                }}
              />
            }
          />
        </AppBar>
      </ThemeProvider>
    </Stack>
  );
}
